import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import {
  CenteredRowContainer,
  centeredRowContainerStyles,
} from 'components/layout/centered-row-container';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { LoyaltySkeletonHeader } from 'pages/loyalty/loyalty-skeleton/loyalty-skeleton-header';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

import { LoyaltySkeleOfferCard } from './loyalty-skeleton-offer-card';

export const LoyaltyOffersSkeletonLoader = () => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <CenteredRowContainer standardPadding>
      <View style={[styles.container, isDesktop && { paddingHorizontal: spacing.$4 }]}>
        <LoyaltySkeletonHeader />
        {Array.from({ length: 7 }).map((_, i) => (
          <LoyaltySkeleOfferCard key={i} />
        ))}
      </View>
    </CenteredRowContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...centeredRowContainerStyles.content,
    maxWidth: WEB_SMALL_MAX_WIDTH,
  },
});
